<template>
  <footer class="footer">
    <div class="copyright">{{ $t('copyright', [currentYear]) }}</div>
  </footer>
</template>

<script lang="ts" setup>
const currentYear = new Date().getFullYear()
</script>
<style lang="less" scoped>
.footer {
  background-color: #fafbfc; // always dark mode
  color: #aeabb2; // always dark mode
  padding-top: 20px;
  // padding: 16px 20px 6px;
  font-size: 12px;
  text-align: center;
  position: fixed; //temp positioning
  bottom: 0;
  width: 100%;
  min-height: 50px;
  display: block;
}
.logo {
  width: 66px;
  height: 20px;
  margin-top: 20px;
}
</style>
